module.exports = __webpack_public_path__ + "images/category_lp/common/icon-company-2_337ecf819ad9dbe8957227877f64e762.png";